import React from "react";

function TrafficHomeOne({ className }) {
  return (
    <section className={`appie-service-area pt-140 pb-180 ${className || ""}`}>
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="appie-traffic-title">
              <h3 className="title">Basketball Rules and Regulations</h3>
              <ul>
                <li>
                  a. Common rules
                  <ul>
                    <li>• 2 Points per win</li>
                    <li>• 1 Point each for a tied match</li>
                  </ul>
                </li>
              </ul>
              <h3>Playing Conditions</h3>
              <ul>
                <li>
                  • Each team will consist of 5 players and 3 substitutes.
                </li>
                <li>
                  • Mixed teams, comprising both male and female players, are
                  allowed.
                </li>
                <li>
                  • There will be 4 Quarters of 10 minutes running time each
                  with 1 Minute break in between{" "}
                </li>
                <li>
                  • In the event of a tie, an additional 5 minutes of overtime
                  will be allotted.
                </li>
                <li>
                  • The substitutions can be done only when the ball in not in
                  play/dead
                </li>
                <li>
                  • Before substituting any player the team should inform the
                  officials or the person on the scoring tables
                </li>
                <li>
                  • Shorts for Basketball is compulsory, track pants are not
                  allowed
                </li>
                <li>
                  • Non marking shoes or pure basketball shoes are compulsory
                </li>
                <li>• All other Standard FIBA rules shall apply</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default TrafficHomeOne;
